export default class GoogleAdsEventType {
  /**
   * This is a static method that returns an instance of the "Event" class.
   * @returns The `Event` instance is being returned. It is obtained by calling the `getInstance`
   * method of the current class (`this`) and passing in the string `'Event'` as an argument.
   */
  static get Event() {
    return this.getInstance('Event');
  }

  /**
   * This is a static method that returns an instance of the "Impression" class.
   * @returns The `Impression` instance is being returned. It is obtained by calling the `getInstance`
   * method of the current class (`this`) and passing in the string `'Impression'` as an argument.
   */
  static get Impression() {
    return this.getInstance('Impression');
  }

  /**
   * The function returns a value from a map based on the input name.
   *
   * @param name - The name of the key in the `statusMap` object that we want to retrieve the value for.
   *
   * @returns the value of the `statusMap` object that corresponds to the `name` parameter passed to the function.
   * If `name` matches one of the keys in `statusMap`, the corresponding value is returned.
   */
  static fromKey(key) {
    const statusMap = {
      Event: GoogleAdsEventType.Event,
      Impression: GoogleAdsEventType.Impression,
    };
    return statusMap[key];
  }

  /**
   * Gets an instance of a GoogleAdsEventType object based on a given name.
   * If the instance does not already exist, it creates a new instance using the configuration provided.
   *
   * @param name a unique identifier used to retrieve or create an instance of the GoogleAdsEventType class.
   * @param configuration an object that contains various properties and values that are used to configure
   * the instance of the GoogleAdsEventType class that is being created.
   *
   * @returns an instance of `GoogleAdsEventType` that corresponds to the given `name`.
   */
  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new GoogleAdsEventType(key);
    }
    return this.instances[key];
  }

  /**
   * This is a constructor function that takes a name as a parameter and sets the name
   * @param name -The `name` property is a string that represents the name of the
   * configuration
   */
  constructor(name) {
    this.name = name;
  }

  /**
   * Method that returns the name property of an object as a string.
   * @returns returns the `name` property of that object as a string.
   */
  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(GoogleAdsEventType, 'instances', { value: {} });
